<template>
  <div>
    投标信息
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
